<template>
  <div class="root">

    <b-navbar class="shadow" fixed="top">

      <b-container>

        <b-navbar-brand href="/" class="py-0">
          <img class="logo-img ml-3" src="@/assets/logo-2-small.svg" />
        </b-navbar-brand>

        <span class="ml-3 mr-auto nav-tagline d-none d-md-block">E-Digging Made Easy</span>

        <a class="ml-auto mr-4" href="https://twitter.com/intent/tweet?url=https://www.sampleroulette.io&text=Check%20out%20SampleRoulette!" title="Share us on Twitter!" target="_blank">
          <p class="nav-icon h4 my-auto">
            <b-icon icon="twitter"></b-icon>
          </p>
        </a>

        <!-- <router-link to="/about">
          <p class="nav-icon h5 mr-3 my-auto">
            <b-icon icon="question-circle-fill" title="About"></b-icon>
          </p>
        </router-link> -->

      </b-container>

    </b-navbar>

    <router-view></router-view>

    <footer>
      <b-container>
        <b-col class="py-3">
          <b-row class="text-center">
            <div>

              <b-button href="https://www.buymeacoffee.com/S.Nutkins" target="_blank" class="mx-1 mt-1" size="sm" style="max-width:150px">
                <b-icon icon="heart-fill" class="mr-1"></b-icon>Donate
              </b-button>

              <router-link to="/suggestion">
                <b-button class="mx-1 mt-1" size="sm" style="max-width:200px">
                  <b-icon icon="lightbulb-fill" class="mr-1"></b-icon>Feedback
                </b-button>
              </router-link>

              <b-button href="\terms.html" class="mx-1 mt-1" size="sm" style="max-width:150px">
                <b-icon icon="info-circle-fill" class="mr-1"></b-icon>Terms of Service
              </b-button>

              <b-button href="\privacy.html" class="mx-1 mt-1" size="sm" style="max-width:150px">
                <b-icon icon="shield-lock-fill" class="mr-1"></b-icon>Privacy
              </b-button>

            </div>
          </b-row>
        </b-col>
      </b-container>
    </footer>

  </div>
</template>

<script>

export default {

  name: "App"
};
</script>

<style>
@font-face {

  font-family: "Reross W05 Rectangular";
  src: url("~@/assets/fonts/6257803/d99f4723-0bd7-416f-a7fa-95e18400c46f.woff2") format("woff2"), url("~@/assets/fonts/6257803/52296bf9-95d5-49e7-9036-c77534d567a9.woff") format("woff");
}

body {
  font-family: "Reross W05 Rectangular" !important;
  font-weight: 200 !important;
}

.root {
  background: #242424;
}

.navbar {
  background: rgb(10, 10, 10);
  height: 66px;
}

.logo-img {
  height: 53px;
}

.nav-tagline {
  color: rgb(136, 136, 136);
}

.nav-icon {
  color: #5520E0
}

.btn {
  background-color: #5520E0 !important;
  border-color: #5520E0 !important;
  border-radius: 100px !important;
}

footer {
  background: rgb(10, 10, 10);
  color: white;
  border-top: 1px solid rgb(54, 54, 54);
}
</style>
